// extracted by mini-css-extract-plugin
export var errorIcon = "_lh-1";
export var nameLogo = "_lh-0";